import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh', // Or '100vh' depending on your layout
    textAlign: 'center',
  };

  return (
    <div style={containerStyle}>
      <h1>404 - Not Found</h1>
      <p>Oops! The page you are looking for could not be found.</p>
      <p>
        You can try going back to the <Link to="/">homepage</Link>.
      </p>
      {/* You can add a search bar or other helpful links here */}
    </div>
  );
}

export default NotFoundPage;